import { Component, inject } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { LoaderService } from 'app/core/services/loader.service';
import { NgIf } from '@angular/common';


@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    animations: [
        trigger('enterAnimation', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('250ms', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                animate('250ms', style({ opacity: 0 }))
            ])
        ])
    ],
    imports: [NgIf]
})
export class LoaderComponent {
  /** Loading state exposed by LoaderService as a signal; read directly in the template. */
  readonly show = inject(LoaderService).isLoading;
}
